import React from "react";
import { useTranslation } from "react-i18next";

/**
 * KPI strip with live per-status counters (roast R04). Clicking a card
 * applies the matching queue filter so the strip doubles as triage.
 */

const KpiStrip = ({ counts, activeFilter, onSelect }) => {
  const { t } = useTranslation();
  if (!counts) return null;

  const cards = [
    {
      id: "total",
      label: t("kpiTotal"),
      value: counts.total,
      dot: "dot-blue",
      filter: { updation_status: null, extraction_status: [] },
    },
    {
      id: "not_yet_started",
      label: t("kpiNotStarted"),
      value: counts.not_yet_started,
      dot: "dot-gray",
      filter: { updation_status: "not_yet_started", extraction_status: [] },
    },
    {
      id: "in_progress",
      label: t("kpiInProgress"),
      value: counts.in_progress,
      subtext:
        counts.in_progress_mine != null
          ? `${counts.in_progress_mine} ${t("mine")}`
          : null,
      dot: "dot-blue",
      filter: { updation_status: "in_progress", extraction_status: [] },
    },
    {
      id: "verify",
      label: t("kpiNeedsVerification"),
      value: counts.verify,
      dot: "dot-orange",
      filter: { updation_status: null, extraction_status: ["Please Verify Once"] },
    },
    {
      id: "failed",
      label: t("kpiFailed"),
      value: counts.failed,
      dot: "dot-red",
      filter: { updation_status: null, extraction_status: ["Not Extracted"] },
    },
    {
      id: "completed",
      label: t("kpiCompleted"),
      value: counts.completed_today != null ? counts.completed : counts.completed,
      subtext:
        counts.completed_today != null
          ? `${counts.completed_today} ${t("completedToday")}`
          : null,
      dot: "dot-green",
      filter: { updation_status: "completed", extraction_status: [] },
    },
  ];

  const isActive = (card) =>
    activeFilter &&
    activeFilter.updation_status === card.filter.updation_status &&
    JSON.stringify(activeFilter.extraction_status || []) ===
      JSON.stringify(card.filter.extraction_status);

  return (
    <div className="kpi-strip" role="group" aria-label={t("quality_level")}>
      {cards.map((card) => (
        <button
          key={card.id}
          type="button"
          className={`kpi-card ${isActive(card) ? "kpi-active" : ""}`}
          onClick={() => onSelect(card.filter)}
        >
          <span className="kpi-value">{card.value ?? 0}</span>
          <span className="kpi-label">
            <span className={`kpi-dot ${card.dot}`} aria-hidden="true" />
            {card.label}
          </span>
          {card.subtext && (
            <span className="kpi-label">{card.subtext}</span>
          )}
        </button>
      ))}
    </div>
  );
};

export default KpiStrip;
